import React from 'react';

export const FullPageSpinner: React.FC<{}> = () => {
  return (
    <div className="w-full h-full pt-8 px-8 flex flex-col items-center justify-center">
      <Spinner/>
    </div>
  );
}

export const Spinner: React.FC<{}> = () => {
  return (
    <svg className="animate-spin h-10 w-10 text-cherry-red-400" viewBox="0 0 24 24" fill="none">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  );
}

export const CustomSpinner: React.FC<{className:string}> = (props)=>{
  return (
    <svg className={`animate-spin ${props.className?props.className:''}`} viewBox="0 0 24 24" fill="none">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  );
}
